import * as Yup from 'yup';

import { UTCoffSet } from '~globals/types/enums';
import { FileObj, Nullable } from '~globals/types/commons';
import { AdminCompany } from '~services/admin/company/types';
import { VALIDATIONS_ERROR } from '~constants/index';

export const UTC_OFFSET_OPTIONS = Object.values(UTCoffSet).map((item) => item);

export const FIELDS_NAME = {
  LOGO: 'logo',
  NAME: 'name',
  CUIT: 'cuit',
  COUNTRY: 'country',
  TIMEZONE: 'timeZone',
  ADDRESS_STREET: 'address',
  ADDRESS_NUMBER: 'addressNumber',
  ADDRESS_FLOOR: 'addressFloor',
  ADDRESS_DEPARTMENT: 'addressDepartment',
  ADDRESS_CITY: 'addressCity',
  ADDRESS_ZIP_CODE: 'addressZipCode',
  ADDRESS_STATE: 'addressState',
  ADDRESS_STREET_BETWEEN_ONE: 'addressStreetBetweenOne',
  ADDRESS_STREET_BETWEEN_TWO: 'addressStreetBetweenTwo',
  CONTACT_NAME: 'contactName',
  CONTACT_DOCUMENT: 'contactDocument',
  CONTACT_PHONE: 'contactPhone',
  CONTACT_MOBILE: 'contactMobile',
  CONTACT_EMAIL: 'contactEmail',
} as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (data: Nullable<AdminCompany>) => ({
  [FIELDS_NAME.LOGO]: [] as FileObj[],
  [FIELDS_NAME.NAME]: data?.name ?? '',
  [FIELDS_NAME.CUIT]: data?.cuit ?? '',
  [FIELDS_NAME.COUNTRY]: String(data?.countryId ?? ''),
  [FIELDS_NAME.TIMEZONE]: data?.timeZone ?? '-03:00',
  [FIELDS_NAME.ADDRESS_STREET]: data?.address ?? '',
  [FIELDS_NAME.ADDRESS_NUMBER]: String(data?.number ?? ''),
  [FIELDS_NAME.ADDRESS_FLOOR]: data?.floor ?? '',
  [FIELDS_NAME.ADDRESS_DEPARTMENT]: data?.department ?? '',
  [FIELDS_NAME.ADDRESS_CITY]: data?.city ?? '',
  [FIELDS_NAME.ADDRESS_ZIP_CODE]: data?.zipCode ?? '',
  [FIELDS_NAME.ADDRESS_STATE]: data?.state ?? '',
  [FIELDS_NAME.ADDRESS_STREET_BETWEEN_ONE]: data?.streetBetween1 ?? '',
  [FIELDS_NAME.ADDRESS_STREET_BETWEEN_TWO]: data?.streetBetween2 ?? '',
  [FIELDS_NAME.CONTACT_NAME]: data?.contactName ?? '',
  [FIELDS_NAME.CONTACT_DOCUMENT]: data?.contactIdentityNumber ?? '',
  [FIELDS_NAME.CONTACT_PHONE]: data?.contactPhone ?? '',
  [FIELDS_NAME.CONTACT_MOBILE]: data?.contactMobile ?? '',
  [FIELDS_NAME.CONTACT_EMAIL]: data?.contactEmail ?? '',
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const validationSchema = (isCarrier: boolean) =>
  Yup.object().shape({
    [FIELDS_NAME.LOGO]: Yup.array().of(Yup.mixed()),
    [FIELDS_NAME.NAME]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
    [FIELDS_NAME.CUIT]: isCarrier
      ? Yup.string().required(VALIDATIONS_ERROR.REQUIRED)
      : Yup.string().notRequired(),
    [FIELDS_NAME.COUNTRY]: isCarrier
      ? Yup.string().required(VALIDATIONS_ERROR.REQUIRED)
      : Yup.string().notRequired(),
    [FIELDS_NAME.TIMEZONE]: Yup.string().notRequired(),
    [FIELDS_NAME.ADDRESS_STREET]: Yup.string().notRequired(),
    [FIELDS_NAME.ADDRESS_NUMBER]: Yup.string().notRequired(),
    [FIELDS_NAME.ADDRESS_FLOOR]: Yup.string().notRequired(),
    [FIELDS_NAME.ADDRESS_DEPARTMENT]: Yup.string().notRequired(),
    [FIELDS_NAME.ADDRESS_CITY]: Yup.string().notRequired(),
    [FIELDS_NAME.ADDRESS_ZIP_CODE]: Yup.string().notRequired(),
    [FIELDS_NAME.ADDRESS_STATE]: Yup.string().notRequired(),
    [FIELDS_NAME.ADDRESS_STREET_BETWEEN_ONE]: Yup.string().notRequired(),
    [FIELDS_NAME.ADDRESS_STREET_BETWEEN_TWO]: Yup.string().notRequired(),
    [FIELDS_NAME.CONTACT_NAME]: Yup.string().notRequired(),
    [FIELDS_NAME.CONTACT_DOCUMENT]: Yup.string().notRequired(),
    [FIELDS_NAME.CONTACT_PHONE]: Yup.string().notRequired(),
    [FIELDS_NAME.CONTACT_MOBILE]: Yup.string().notRequired(),
    [FIELDS_NAME.CONTACT_EMAIL]: isCarrier
      ? Yup.string().notRequired()
      : Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
  });

export const getOptionalText = (text: string, enabled: boolean): string =>
  enabled ? `${text} (Opcional)` : text;
